export default "__VITE_ASSET__BYilZlx4__"